import React from 'react';
import classes from './Modal.css';
import Auxilary from '../../../hoc/auxilary';
import Backdrop from '../Backdrop/Backdrop';

const modal = (props) =>
(
    <Auxilary>
        <Backdrop show = {props.show} clicked = {props.modalClosed}/>
        <div className = {classes.Modal}
            style = {{
                // will change style based on whether the 'show' prop is true
                transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: props.show ? '1' : '0'
            }}>  
            {props.children}
        </div>
    </Auxilary>

);

export default modal;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js